import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareSummaryEmbedRoute: InvariantJiraRoute = {
	name: 'software-summary-embed',
	path: '/jira/software/projects/:projectKey/summary/embed',
};
